<template>
  <page-outline :title="$t('common.entity_account.entity_account_details')">
    <template slot="pageContent">
      <b-container fluid>
        <b-row class="justify-content-start mb-5">
          <b-col cols="4" sm="3" md="2" xl="1">
            <back-button :returnUrl="returnUrl"></back-button>
          </b-col>
          <b-col cols="4" sm="3" md="2" xl="1" @click="getTrack()">
            <b-button class="back-button">
              <i class="fa-solid fa-rotate-right fs-14px"></i>
              {{ $t('common.rfrsh') }}
            </b-button>
          </b-col>
        </b-row>
        <spinner v-if="activateSpinner"></spinner>
        <template v-else-if="listItemsEntityAccount.length > 0">
          <div>
            <form-accordion :title="$t('common.entity_account.entity_account_details')" :isTitleUpperCase="false">
              <b-row class="form-group">
                <b-col sm="4" class="mb-5">
                  <form-read-group-label-input v-if="listItemsEntityAccount[0].DateAction !== ''"
                    :inputLabel="$t('common.entity_account.date_action')" :inputValue="getDate(listItemsEntityAccount[0].DateAction)">
                  </form-read-group-label-input>
                </b-col>
                <b-col sm="4" class="mb-5">
                  <form-read-group-label-input v-if="listItemsEntityAccount[0].IbanEncrypted !== ''"
                    :inputLabel="$t('common.entity_account.iban_encrypted')" :inputValue="listItemsEntityAccount[0].IbanEncrypted">
                  </form-read-group-label-input>
                </b-col>
                <b-col sm="4" class="mb-5">
                  <form-read-group-label-input v-if="listItemsEntityAccount[0].IbanReference !== ''"
                    :inputLabel="$t('common.entity_account.iban_reference')" :inputValue="listItemsEntityAccount[0].IbanReference">
                  </form-read-group-label-input>
                </b-col>
                <b-col sm="4" class="mb-5">
                  <form-read-group-label-input v-if="listItemsEntityAccount[0].StatusIban !== ''"
                    :inputLabel="$t('common.entity_account.iban_status')" :inputValue="$t('common.entity_account.synchro_type_' + listItemsEntityAccount[0].StatusIban)">
                  </form-read-group-label-input>
                </b-col>
                <b-col sm="4" class="mb-5">
                  <form-read-group-label-input v-if="listItemsEntityAccount[0].StatusImportIban !== ''"
                    :inputLabel="$t('common.entity_account.iban_import_status')" :inputValue="$t('common.entity_account.iban_import_status_' + listItemsEntityAccount[0].StatusImportIban)">
                  </form-read-group-label-input>
                </b-col>
                <b-col sm="4" class="mb-5">
                </b-col>
              </b-row>
            </form-accordion>
          </div>
          <hr class="mx-auto" />
          <div>
            <form-accordion :title="$t('common.entity_account.entity_account_history')" :isTitleUpperCase="false">
              <table class="table table-striped" v-if="listItemsEntityAccount.length > 0">
                <tbody>
                <tr>
                  <th class="text-center w-25">
                    {{ $t('common.entity_account.date_action') }}
                  </th>
                  <th class="text-center w-25">
                    {{ $t('common.entity_account.iban_status') }}
                  </th>
                  <th class="text-center w-25">
                    {{ $t('common.entity_account.iban_import_status') }}
                  </th>
                  <th class="text-center w-25">
                    {{ $t('common.entity_account.file_reference') }}
                  </th>
                </tr>
                <tr v-for="iban in listItemsEntityAccount" :key="listItemsEntityAccount.IdEntityAccountFile">
                  <td class="text-center w-25">
                    <div v-if="iban.DateAction !== ''">{{ getDate(iban.DateAction) }}</div>
                  </td>
                  <td class="text-center w-25">
                    <div v-if="iban.StatusIban !== ''">{{ $t('common.entity_account.synchro_type_' + iban.StatusIban) }}</div>
                  </td>
                  <td class="text-center w-25">
                    <div v-if="iban.StatusImportIban !== ''">{{ $t('common.entity_account.iban_import_status_' + iban.StatusImportIban) }}</div>
                  </td>
                  <td class="text-center w-25">
                    <div v-if="iban.FileReference !== ''">{{ iban.FileReference }}</div>
                  </td>
                </tr>
                </tbody>
              </table>
            </form-accordion>
          </div>
        </template>
      </b-container>
    </template>
  </page-outline>
</template>

<script>
import PageOutline from '@/components/common/PageOutline.vue'
import backButton from "@/components/common/backButton.vue"
import Spinner from '@/components/common/spinner.vue'
import formAccordion from "@/components/common/FormAccordion.vue";
import FormReadGroupLabelInput from "@/components/common/formReadGroupLabelInput.vue";
import {errorMessageAlert} from "@/helpers/alert"
import moment from "moment-timezone"

export default {
  name: 'EntityAccountDetails',
  components: {
    FormReadGroupLabelInput,
    'page-outline': PageOutline,
    'back-button': backButton,
    'spinner': Spinner,
    'form-accordion': formAccordion,
  },
  data () {
    return {
      activateSpinner: false,
      listItemsEntityAccount: [],
      returnUrl: '/entityAccountPage/EntityAccount',
      timezone: '+00:00'
    }
  },
  created () {
    this.timezone = moment.tz.guess()
    this.IdEntityAccount = this.$route.params.idEntityAccount

    this.getEntityAccount()

    this.$bus.$emit('change-mobile-header', {
      backLink: false,
      navbarInnerStyle: 'justify-content:start;',
      navTitle: this.$t('common.entity_account.entity_account_details'),
    })

    this.$f7.initPullToRefresh()
    this.$bus.$emit('right-panel-set-feature', 'filter-messages')
  },
  methods: {
    getEntityAccount() {
      let that = this
      let params = {
        IdEntityAccount: this.IdEntityAccount
      }

      this.$engine.firstOn().entityAccount.getEntityAccount(params).then((resp) => {

        let EntityAccountList = {}

        EntityAccountList = resp.data.EntityAccount

        that.updateEntityAccount(EntityAccountList)

        this.$f7.pullToRefreshDone()
        that.activateSpinner = false
      })
      .catch(error => {
        errorMessageAlert(error, that)
      })
    },
    getDate (date) {
      if (!date || date == ''){
        return '-'
      }
      const hasTimezone = /([+-]\d{2}:\d{2}|Z)$/.test(date);
      const isoWithTZ = hasTimezone ? date : date + 'Z';
      return moment(isoWithTZ).tz(this.timezone).format('DD/MM/YYYY HH:mm:ss.SSS');
    },
    updateEntityAccount(EntityAccountList) {
      this.listItemsEntityAccount = EntityAccountList
    }
  }
}
</script>
